<template>
  <div
    class="ui-loading"
    :class="{ 'ui-loading--inline': inline }"
    role="status"
    aria-live="polite"
  >
    <LoaderCircle class="ui-spin" :size="inline ? 20 : 28" :stroke-width="2.4" aria-hidden="true" />

    <span class="ui-loading__label">{{ label ?? $t("Loading...") }}</span>
  </div>
</template>

<script setup lang="ts">
import { LoaderCircle } from "lucide-vue-next";

withDefaults(
  defineProps<{
    label?: string;
    inline?: boolean;
  }>(),
  {
    label: undefined,
    inline: false,
  },
);
</script>
